/**
 * Módulo: Datos de mercado (Market Pro)
 *
 * IMPORTANTE — SIN UI ni route propia (mismo patrón que el módulo `ia`):
 * existe como **ítem contratable del plan**. Un plan lo incluye —o no— en
 * `modulosIncluidos`, eso se denormaliza a `empresas.modulosDisponibles`
 * (sincronizarModulosPlan) y el front gatea con `tieneMercado(empresa)`
 * (lib cuadroGeneral, §6.7).
 *
 * Qué habilita: la sección Mercado del Pulso general (share de tus
 * categorías, spread, posición — datos de Market Pro) y el tile de share
 * del hero. NO confundir con el módulo `mercado` (Explorador de mercado,
 * herramienta del consultor) — son dos servicios distintos (17-jul-2026,
 * decisión Mariano: ambos servicios de mercado gateados por plan).
 */
export default {
  id: 'mercado-datos',
  nombre: 'Datos de mercado',
  descripcion: 'Market Pro para el cliente: sección Mercado del Pulso general (share, spread, posición de tus categorías).',
  icono: 'trending-up',
  tipo: 'operativo',
  version: '0.1.0',

  // Sin rutas ni menú: vive embebido en el Pulso general.
  routes: [],
  menuItems: [],

  features: ['mercado-datos-pulso'],

  // Vacío a propósito: no se gatea por rol — se gatea por plan.
  permisoModulos: [],

}
